import { useMutation, useQuery } from '@tanstack/react-query';
import request from 'shared/lib/request';
import { requireValue } from 'shared/lib/assert';
import ServerErrorHandler from 'shared/feedback/ErrorHandler';
import { referenceDataKeys } from './keys';

// TODO(ts-rest): these two stay on the raw request wrapper because their GET query
// params aren't in the OpenAPI contract yet (FUTURE_REFACTORS item 10):
//   - useReferenceData: the /reference-data list GET types only { documentSuperId, superId },
//     but this call also passes revisionId / current / metadata.
//   - useGetXliffDownload: the /reference-data/xliff/:id GET types xliffId as REQUIRED,
//     but the download call omits it.
// Migrate once the contract adds those params.

export function useReferenceData(referenceDataId: string, documentId: number | string, revisionId?: string) {
  return useQuery({
    queryKey: referenceDataKeys.detail(documentId, referenceDataId),

    queryFn: async () => {
      const res = await request.get(
        `/gaby/reference-data?documentSuperId=${documentId}&superId=${referenceDataId}&revisionId=${revisionId}&current=true&metadata=true`
      );

      return res.data[0];
    },
  });
}

export function useGetXliffDownload(documentId?: number | string) {
  return useMutation({
    mutationFn: async () => {
      const res = await request.get(`/gaby/reference-data/xliff/${requireValue(documentId, 'xliff download ran before the document loaded')}`);
      return { data: res.data, targetLocale: res.data.targetLocale, sourceLocale: res.data.sourceLocale };
    },

    onError: ServerErrorHandler,
  });
}
